import {NgModule} from '@angular/core';

import {FuseSidebarComponent} from '@fuse/components/sidebar/sidebar.component';

@NgModule({
    declarations: [FuseSidebarComponent],
    exports: [FuseSidebarComponent]
})
export class FuseSidebarModule {}
